import React, { useState } from "react";
import PropTypes from "prop-types";

const RadioButton = ({ buttons, model, name, isValid }) => {
  const [setectedOption, setSelectedOption] = useState("");

  const handleCheckBox = (event) => {
    setSelectedOption(event.target.value);
  };

  const elements = buttons.map(function (el, index) {
    return (
      <div
        key={index}
        className={`${
          el.value === setectedOption ? "text-cyan-400" : "text-blueGray-800"
        } block mt-5 w-full`}
      >
        <label
          className={`flex flex-col items-center justify-center mx-5 font-semibold text-2xl border ${
            el.value === setectedOption && "border-cyan-300"
          } rounded cursor-pointer shadow hover:border-cyan-300 px-6 py-4`}
          htmlFor={el.value}
        >
          {el.img && <img src={el.img.url} alt={el.img.alt} className="w-32" />}

          <input
            className="hidden"
            key={index}
            type="radio"
            id={el.value}
            name={`${model}[${name}]`}
            value={el.value}
            onClick={() => {
              isValid(event);
              handleCheckBox(event);
            }}
          />
          {el.label}
        </label>
      </div>
    );
  });
  return (
    <div className="flex flex-col items-center justify-center mt-5">
      {elements}
    </div>
  );
};

RadioButton.propTypes = {
  buttons: PropTypes.array,
  name: PropTypes.string,
  model: PropTypes.string,
};

export default RadioButton;
